"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no enrollment with a given course id exists
 * @param {string} courseId
 */
class CourseEnrollmentDoesNotExistError extends client_library_1.ExtendableError {
    constructor(courseId) {
        super(`course enrollment: courseId ${courseId} does not exist`);
        this.courseId = courseId;
    }
}
exports.default = CourseEnrollmentDoesNotExistError;
//# sourceMappingURL=CourseEnrollmentDoesNotExistError.js.map